import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { AnnotationPreview } from '../../views/home/projectDetails/AnnotationPreview.view';
import { ProjectDetailsView } from '../../views/home/projectDetails/ProjectDetails.view';
import { ProjectsView } from '../../views/home/Projects.view';
import { Home } from '../config/Home';

export const ProjectsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Projects.List.Path}>
      <ProjectsView />
    </Route>
    <Route path={Home.Projects.Details.Preview.Path}>
      <AnnotationPreview />
    </Route>
    <Route path={Home.Projects.Details.Path}>
      <ProjectDetailsView />
    </Route>
  </SwitchWithNotFound>
);
